import { Dialog, DialogTitle, DialogContent, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MasterDriverPage from '../../master-data/driver/MasterDriverPage';
import { useLanguage } from '../../../utils/i18n';

export default function DriverDialog({ open, onClose }) {
  const { t } = useLanguage();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle component="div" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        {t('dashboardAsset.activeDrivers', 'Active Drivers')}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 2, bgcolor: '#f4f6f8' }}>
        <MasterDriverPage />
      </DialogContent>
    </Dialog>
  );
}
